import { useEffect } from "react";

/**
 * Client-side content protection deterrent.
 * Disables right-click context menu, image dragging, and common
 * copy/save keyboard shortcuts across the site.
 *
 * NOTE: This is a deterrent only. Determined users can still bypass
 * it via dev tools or by viewing source. True copyright protection
 * is legal, not technical — see /disclaimer.
 */
const ContentProtection = () => {
  useEffect(() => {
    const blockContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    const blockDragStart = (e: DragEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === "IMG" || target.tagName === "VIDEO")) {
        e.preventDefault();
      }
    };

    const blockKeys = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      // Block Ctrl/Cmd + S (save), P (print), U (view source),
      // and Ctrl/Cmd + Shift + I/J/C (devtools), F12.
      if (e.key === "F12") {
        e.preventDefault();
        return;
      }
      if ((e.ctrlKey || e.metaKey) && ["s", "u", "p"].includes(key)) {
        e.preventDefault();
        return;
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(key)) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("dragstart", blockDragStart);
    document.addEventListener("keydown", blockKeys);

    // Disable image dragging via CSS as a fallback.
    const style = document.createElement("style");
    style.setAttribute("data-content-protection", "true");
    style.innerHTML = `
      img, video { -webkit-user-drag: none; user-select: none; -webkit-user-select: none; }
    `;
    document.head.appendChild(style);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("dragstart", blockDragStart);
      document.removeEventListener("keydown", blockKeys);
      style.remove();
    };
  }, []);

  return null;
};

export default ContentProtection;
